export const GENERAL_SETTINGS = Object.freeze([
  { id: 'dashboard', label: 'Дашборд', admin: true },
  { id: 'analytics', label: 'Показатели', permission: 'metrics.configure' },
  { id: 'temperature', label: 'Температура', permission: 'metrics.configure' },
  { id: 'reviews', label: 'Отзывы', permission: 'metrics.configure' },
  { id: 'inventory', label: 'Склад', permission: 'integrations.manage' },
  { id: 'audit', label: 'Аудит', admin: true }
]);
export const allowedGeneralSettings = auth => auth.isAdmin ? [...GENERAL_SETTINGS] : [];
export const generalSettingsLocation = (section, query = {}) => ({ path: '/settings', query: { ...query, tab: 'general', section } });
